import React, { useEffect } from "react";
import Amplify from "aws-amplify";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "antd/dist/antd.css";
import awsconfig from "./aws-exports";
import awsconfig2 from "./aws-exports-add";
import { useViewport } from "./hooks/useViewport";
import { isMobileOrTablet } from "./common-definitions/device";
import NoAuthedApp from "./NoAuthedApp";

Amplify.configure(awsconfig);
Amplify.configure(awsconfig2);
Sentry.init({
  dsn: `${process.env.REACT_APP_SENTRY_DSN}`,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  normalizeDepth: 0,
});

const App = () => {
  const isMobile = useViewport() <= 1024 || isMobileOrTablet();

  useEffect(() => {
    const doc = document.documentElement;
    function updateSize() {
      const oldWidth = parseFloat(
        getComputedStyle(document.body)?.getPropertyValue("--window-width") ||
          "0"
      );
      const oldHeight = parseFloat(
        getComputedStyle(document.body)?.getPropertyValue("--window-height") ||
          "0"
      );
      if (
        !oldWidth ||
        !oldHeight ||
        (oldWidth !== window.innerWidth && oldHeight !== window.innerHeight)
      ) {
        doc.style.setProperty("--window-height", `${window.innerHeight}px`);
        doc.style.setProperty("--window-width", `${window.innerWidth}px`);
      }
    }
    function setVideoRatio() {
      setTimeout(() => {
        doc.style.setProperty("--video-sp-ratio", `${1 / 1.5}`);
      }, 500);
    }
    window.addEventListener("resize", updateSize);
    window.addEventListener("orientationchange", setVideoRatio, false);
    updateSize();
    setVideoRatio();
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("orientationchange", setVideoRatio, false);
    };
  }, []);

  useEffect(() => {
    if (isMobile) {
      document.body.classList.add("is-mobile");
    } else {
      document.body.classList.remove("is-mobile");
    }

    if (window !== window.parent) {
      document.body.classList.add("is-in-iframe");
    } else {
      document.body.classList.remove("is-in-iframe");
    }
  }, [isMobile]);

  return <NoAuthedApp />;
};

export default App;
